import React from 'react';
import { Box, Button } from '@mui/material';
import { Bot, Rocket } from 'lucide-mui';
import { ToggleSetting, SettingsSection } from '../common';
import GoogleMeetIntegration from './GoogleMeet';
import ContactSalesForm from '../../sales/ContactSalesForm';
import ActionDialog from '../../globalModals/ActionDialog';

const MeetingBotSettings = () => {
  const [salesDialogOpen, setSalesDialogOpen] = React.useState(false);

  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        overflow: 'auto',
        bgcolor: 'transparent',
        px: 3,
        pt: 1,
        pb: 3,
        '& > *:not(:last-child)': {
          mb: 3,
        },
      }}
    >
      <SettingsSection title="Meeting Bot">
        <ToggleSetting
          checked={false}
          onChange={() => {}}
          label="Meeting Bot Recorder (Beta)"
          description="Connect your Google Calendar to automatically record and transcribe your Google Meet calls. Our bot will join your meetings, record the conversation, and provide you with searchable transcripts and AI summaries."
          icon={<Bot sx={{ width: 24, height: 24 }} />}
        >
          <Box sx={{ mt: 2 }}>
            <GoogleMeetIntegration />
          </Box>
        </ToggleSetting>
      </SettingsSection>

      <SettingsSection title="Enterprise Features">
        <ToggleSetting
          checked={false}
          onChange={() => {}}
          label="Meeting Bot for Organizations"
          description="Scale your meeting intelligence with unlimited recordings, custom AI models for industry-specific terminology, team-wide meeting analytics, and enterprise security controls for your meeting recordings and transcripts."
          icon={<Rocket sx={{ width: 24, height: 24 }} />}
          rightElement={
            <Button
              onClick={() => setSalesDialogOpen(true)}
              variant="contained"
              color="primary"
              sx={{
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.875rem',
                py: 1,
                px: 2.5,
              }}
            >
              Contact Sales
            </Button>
          }
        />
      </SettingsSection>

      <ActionDialog
        title="Get in touch"
        open={salesDialogOpen}
        onClose={() => setSalesDialogOpen(false)}
        maxWidth="md"
        fullWidth
        actions={[]}
      >
        <Box>
          <ContactSalesForm formSource="Meeting Bot Settings - Organization Enquiry" />
        </Box>
      </ActionDialog>
    </Box>
  );
};

export default MeetingBotSettings;
